import { apiSlice } from '../api/apiSlice';

export const announcementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAnnouncement: builder.query({
      query: () => ({
        url: '/announcement/all',
        method: 'Get',
      }),
      providesTags: ['Announcement'],
    }),
    editAnnouncement: builder.mutation({
      query: (body) => ({
        url: '/announcement/edit',
        method: 'Put',
        body,
      }),
      invalidatesTags: ['Announcement'],
    }),
  }),
});
export const { useGetAnnouncementQuery, useEditAnnouncementMutation } = announcementApiSlice;
